/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://m5st77xq2fcdhdhjehm4ahtmmi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-jxd7eryh5ncovaegytd5kxth7m",
    "aws_cloud_logic_custom": [
        {
            "name": "waitlistAPI",
            "endpoint": "https://t7jstx5z3e.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "calculatorSubmissions-staging",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
